import * as React from "react";
import type { SVGProps } from "react";
const SvgIcChevronUp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#040747"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m5 15.5 7-7 7 7"
    />
  </svg>
);
export default SvgIcChevronUp;
